import type { GroupBase, ValueContainerProps } from 'react-select';
import { components } from 'react-select';
import type { OptionType } from '../types';

export const SummaryValueContainer = <T extends OptionType>(props: ValueContainerProps<T, true, GroupBase<T>>) => {
  const { children, getValue, selectProps } = props;

  const selected = getValue();
  const totalCount = (selectProps.options ?? []).length;
  const summaryLabelFn = (selectProps as unknown as { summaryLabel?: (s: number, t: number) => string }).summaryLabel;
  const label = summaryLabelFn?.(selected.length, totalCount) ?? `${selected.length} selected`;

  return (
    <components.ValueContainer {...props}>
      <div style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, overflow: 'hidden' }}>
        {children}
      </div>
      <span className="truncate leading-6">{label}</span>
    </components.ValueContainer>
  );
};
